import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {Dropdown, Confirm} from 'semantic-ui-react';
import _ from 'lodash';
import {connect} from 'react-redux';
import REST from 'go/requests/rest';
import {
  STATUS_APPROVED_BY_RECIPIENT,
  STATUS_DISAPPROVED_BY_RECIPIENT,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_STOCKPILE,
  STATUS_SUBAWARD_ACCEPTED,
  STATUS_INELIGIBLE,
  STATUS_SAVED_FOR_LATER,
  PROGRAM_TYPE_PASSTHROUGH,
  STATUS_PENDING_SUBMISSION,
} from 'app-ui-componentlibrary/dist/common/constants';
import {getTimestampNowISO, getSubOrganizationId} from 'common/utils';
import {getTaskIdForEntity} from './utils';
import {DeleteModal} from 'app-ui-componentlibrary';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class CreateEntityActionButton extends React.Component {
  state = {
    closeoutInitiatedOpen: false,
    selectedEntityType: {},
    deleteModalOpen: false,
  };

  setDeleteModal = () => {
    this.setState({deleteModalOpen: !this.state.deleteModalOpen});
  };

  timeout(ms) {
    return () => new Promise((resolve) => setTimeout(resolve, ms));
  }

  navigateToApplication(grantId, entity, entityType) {
    const {token, permissions, propertyData} = this.props;

    const applicationId = entity && entity.entityId;
    switch (entityType) {
      case 'continueApplication':
        this.props.history.push(`/application/${applicationId}/edit`);
        break;
      case 'subApplication':
        this.props.history.push(`/subApplication/${applicationId}`);
        break;
      case 'changeSubApplicationStatus':
        if (entity.payload && entity.payload.programType === PROGRAM_TYPE_PASSTHROUGH) {
          this.changeSubAppStatusPassthrough(entity, token, permissions);
        } else {
          this.changeSubAppStatusNonPassthrough(entity, token, permissions);
        }
        break;
      case 'viewSubApplication':
        const {status, subGrantId} = entity;
        if (
          (status === STATUS_SUBMITTED_TO_FEMA ||
            status === STATUS_SUBAWARD_ACCEPTED ||
            status === STATUS_INELIGIBLE) &&
          subGrantId
        ) {
          this.props.history.push(`/subGrant/${subGrantId}/subApplication`);
        } else {
          this.props.history.push(`/subApplication/${applicationId}/view`);
        }
        break;
      case 'reviewSubApplication':
        getTaskIdForEntity(
          token,
          permissions,
          entity.entityId,
          'reviewSubapplication'
        ).then((taskId) => {
          this.props.history.push(`/tasks/${taskId}`);
        });
        break;
      case 'viewApplication':
        this.props.history.push(`/grant/${grantId}/application`);
        break;
      case 'reopenApplication':
        this.props.showReopenModal(entity);
        break;
      case 'closeoutReport':
        this.props.showInitiateCloseoutReportModal(entity, entityType);
        break;
      case 'cancelCloseoutReport':
        this.props.showCancelCloseoutReportModal(entity);
        break;
      case 'submitToFEMA':
        getTaskIdForEntity(
          token,
          permissions,
          entity.entityId,
          'subAppSubmissionToFEMA'
        ).then((taskId) => {
          this.props.history.push(`/tasks/${taskId}`);
        });
        break;
      case 'subCloseoutReport':
        this.props.showInitiateSubCloseoutReportModal(entity, entityType);
        break;
      case 'cancelSubCloseoutReport':
        this.props.showCancelSubCloseoutReportModal(entity);
        break;
      case 'propertyData':
        if (_.isEmpty(propertyData)) {
          this.createEntity(entityType);
        } else {
          let updEntity = _.first(propertyData);
          updEntity.status = STATUS_PENDING_SUBMISSION;
          updEntity.statusTimestamp = getTimestampNowISO();
          this.updateEntity(updEntity);
        }
        break;

      default:
        this.createEntity(entityType);
    }
  }

  updateEntity(entity) {
    const {token, onError} = this.props;

    REST.dynamicData
      .updateEntity(token, entity)
      .then(REST.handler.handleResponse)
      .then((entityData) => {
        if (entityData.errors != null) {
          onError(entityData);
        } else {
          this.setState({
            entityType: entityData.entityType,
            entityId: entityData.entityId,
          });
        }
      });
  }

  createEntity(entityType) {
    const {token, grantId, onError, subGrantId} = this.props;
    let createEntityRequest = 'createEntity';
    let id = grantId;
    if (
      subGrantId &&
      (this.props.entityType === 'subGrant' || this.props.entityType === 'propertyData')
    ) {
      if (entityType === 'amendment') {
        entityType = 'subAmendmentRecommendation';
      }
      createEntityRequest = 'createEntityFromSubGrant';
      id = subGrantId;
    }
    REST.dynamicData[createEntityRequest](token, id, entityType)
      .then(REST.handler.handleResponse)
      .then((entityData) => {
        if (entityData.errors != null) {
          onError(entityData);
        } else {
          this.setState({
            entityType: entityData.entityType,
            entityId: entityData.entityId,
          });
        }
      });
  }

  navigationToApplicationCall = (entityType) => {
    REST.dynamicData
      .getEntityById(this.props.token, this.props.entityId)
      .then((res) => forceJsonResponse(res, MONO))
      .then((resJson) => {
        this.navigateToApplication(null, resJson, entityType);
      });
  };

  doEntityAction(entityType) {
    const {token, grantId} = this.props;
    if (
      entityType === 'viewSubApplication' ||
      entityType === 'reviewSubApplication' ||
      entityType === 'changeSubApplicationStatus' ||
      entityType === 'submitToFEMA'
    ) {
      this.navigationToApplicationCall(entityType);
    } else if (entityType === 'deleteSubApplication') {
      this.setDeleteModal();
    } else if (this.props.entityType === 'subApplication') {
      REST.dynamicData
        .getEntityById(this.props.token, this.props.entityId)
        .then((res) => forceJsonResponse(res, MONO))
        .then((resJson) => {
          this.navigateToApplication(null, resJson, this.props.entityType);
        });
    } else if (this.props.entityType === 'subGrant') {
      this.navigationToApplicationCall(entityType);
    } else {
      REST.dynamicData
        .getAllByGrantIdAndEntityType(token, grantId, 'application')
        .then(REST.handler.handleResponse)
        .then((data) => {
          this.navigateToApplication(grantId, data[0], entityType);
        });
    }
  }

  deleteActionForModal = (token) => {
    REST.dynamicData
      .deleteEntity(token, this.props.entityId)
      .then(REST.handler.handleResponse)
      .then(() => {
        const win = _.isEqual(this.props.location.pathname, '/subgrants')
          ? window.open(`/subgrants`, '_self')
          : window.open(`/grants`, '_self');
        if (win != null) {
          win.focus();
        }
      })
      .catch((error) => console.log(error));
  };

  changeSubAppStatusPassthrough(entity, token, permissions) {
    if (
      entity.status === STATUS_SAVED_FOR_LATER ||
      entity.status === STATUS_DISAPPROVED_BY_RECIPIENT
    ) {
      const {organizationId, fundingOpportunityId} = entity;
      REST.dynamicData
        .grantIdByFOIdAndOrgId(organizationId, fundingOpportunityId)
        .then((res) => forceJsonResponse(res, MONO))
        .then((resJson) => {
          const grantId = resJson.grantId;

          const topLevelParameters = {
            entityId: entity.entityId,
            entityType: entity.entityType,
            fundingOpportunityId: fundingOpportunityId,
            programId: entity.programId,
            organizationId: organizationId,
            subOrgId: getSubOrganizationId(entity),
            contextId: parseInt(fundingOpportunityId),
            contextType: 'fo',
            applicationTitle: entity.payload.applicationTitle,
            grantId: grantId,
          };
          const startingVariables = {
            ...topLevelParameters,
            submittedUserId: entity.payload.submitterLoginName,
            submittedTimestamp: entity.payload.submittedTimestamp,
          };
          REST.workflow
            .startsubApplicationProcess(
              token,
              'recipientReviewPassthrough',
              topLevelParameters,
              startingVariables
            )
            .then(REST.handler.handleResponse)
            .then((res) => {
              getTaskIdForEntity(
                token,
                permissions,
                entity.entityId,
                'reviewSubapplication',
                30
              ).then((taskId) => {
                this.props.history.push(`/tasks/${taskId}`);
              });
            })
            .catch((error) => {
              console.error('error');
            });
        });
    }
  }

  changeSubAppStatusNonPassthrough(entity, token, permissions) {
    if (
      entity.status === STATUS_STOCKPILE ||
      entity.status === STATUS_APPROVED_BY_RECIPIENT ||
      entity.status === STATUS_DISAPPROVED_BY_RECIPIENT
    ) {
      const topLevelParameters = {
        entityId: entity.entityId,
        entityType: entity.entityType,
        fundingOpportunityId: entity.fundingOpportunityId,
        organizationId: entity.organizationId,
        subOrgId: getSubOrganizationId(entity),
        contextId: parseInt(entity.categoryId),
        contextType: 'pc',
        applicationTitle: entity.payload.applicationTitle,
      };
      const startingVariables = {
        entityId: entity.entityId,
        entityType: entity.entityType,
        fundingOpportunityId: entity.fundingOpportunityId,
        organizationId: entity.organizationId,
        subOrgId: getSubOrganizationId(entity),
        contextId: parseInt(entity.categoryId),
        contextType: 'pc',
        applicationTitle: entity.payload.applicationTitle,
        submittedUserId: entity.payload.submitterLoginName,
        submittedTimestamp: entity.payload.submittedTimestamp,
      };
      REST.workflow
        .startsubApplicationProcess(
          this.props.token,
          'hazardMitigationRecipientReview',
          topLevelParameters,
          startingVariables
        )
        .then(REST.handler.handleResponse)
        .then((res) => {
          getTaskIdForEntity(
            token,
            permissions,
            entity.entityId,
            'reviewSubapplication',
            30
          ).then((taskId) => {
            this.props.history.push(`/tasks/${taskId}`);
          });
        })
        .catch((error) => {
          console.error('error');
        });
    }
  }

  render() {
    const {actions, buttonType} = this.props;
    const {entityType, entityId, errors} = this.state;
    if (entityId && entityType) {
      return <Redirect to={`/${entityType}/${entityId}/edit`} push />;
    }

    if (!_.isEmpty(actions)) {
      return buttonType === 'primary' ? (
        <Dropdown
          selectOnNavigation={false}
          selectOnBlur={false}
          text={'Select an action'}
          className="dropdown-menu-button"
          name="actionButton"
          id="actionButton"
          onChange={(e, {name, value}) => this.doEntityAction(value)}
          options={actions}
          value={''}
        />
      ) : errors ? (
        this.displayErrorMessage(errors)
      ) : (
        <div>
          <Dropdown
            selectOnNavigation={false}
            selectOnBlur={false}
            selection
            basic
            fluid
            text={'Select an action'}
            name="actionButton"
            id="actionButton"
            onChange={(e, {name, value}) => this.doEntityAction(value)}
            options={actions}
            value={''}
          />
          <DeleteModal
            displayTitle={'Delete subapplication'}
            open={this.state.deleteModalOpen === true}
            cancelAction={this.setDeleteModal}
            deleteAction={() => this.deleteActionForModal(this.props.token)}
            displayText={
              'Are you sure you want to delete this subapplication? This action will remove the subapplication permanently from the FEMA GO system. This action cannot be undone'
            }
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
  };
};

const ShowCreateEntityActionButtonWithRouter = withRouter(CreateEntityActionButton);

export default connect(mapStateToProps, null)(ShowCreateEntityActionButtonWithRouter);
